// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-checkbox .custom-control-label[data-v-5a423d78]::before {\n  border-radius: 0.5rem !important;\n  cursor: pointer;\n}\n.no-image-gallery i.far[data-v-5a423d78] {\n  font-size: 42px;\n  color: #959595;\n}\n.mdb-time-picker .clockpicker-span-hours[data-v-5a423d78],\n.mdb-time-picker .clockpicker-span-minutes[data-v-5a423d78] {\n  color: #4285f4 !important;\n}\n", ""]);
// Exports
module.exports = exports;
